// eslint-disable-next-line import/no-cycle
import { store } from '../redux/store';
import { setUserContext, initChat } from '../redux/slices/chat';

const setChatSession = (user) => {
  if (user) {
    // Set user context for internal chat widget
    store.dispatch(
      setUserContext({
        name: user?.name?.ar,
        email: user?.email,
        phone: user?.mobile,
        businessId: user?.business?.id,
        businessName: user?.business?.name?.ar,
      })
    );
    // Switch the chat widget to this business's own conversation so a
    // previous business's chat never leaks into the newly active one.
    store.dispatch(initChat({ userId: user?.id, businessId: user?.business?.id }));
    if (user && window.gtag) {
      window?.gtag('set', { user_id: user?.id });
    }
    if (window?.smartlook) {
      window.smartlook('identify', user?.id, {
        name: user?.name?.ar,
        email: user?.email,
        mobile: user?.mobile,
        business_id: user?.business?.id,
        business_name: user?.business?.name?.ar,
        bundle: user?.business?.active_subscription?.plan?.product?.name?.en,
        subscription_type: user?.business?.active_subscription
          ? (user?.business?.monthly && 'Monthly') || 'Yearly'
          : 'Trial',
        number_of_pos: user?.business?.pos_count,
        inventory: user?.business?.featuresactive?.includes('feature.stock'),
        expenses: user?.business?.featuresactive?.includes('feature.expense'),
        number_of_sale_teams: user?.business?.teams_count,
        tax_exemption: user?.business?.featuresactive?.includes('feature.billing.tax_exemption'),
      });
    }
    if (window?.hj) {
      window.hj('identify', user?.id, {
        join_date: user?.business?.created_at ? `${user.business.created_at.slice(0, 10)}Z` : null,
        subscription_start_date: user?.business?.subscription_date
          ? `${user.business.subscription_date}Z`
          : '3000-01-01Z',
        environment: window.location.hostname === 'web.sowan.sa' ? 'production' : 'sandbox',
      });
    }
    // window?.userpilot?.identify(user?.id, [
    //   {
    //     name: user?.name?.ar,
    //     email: user?.email,
    //     created_at: Math.floor(new Date(user?.date_joined).getTime() / 1000).toString(),
    //     role: user?.business?.is_owner ? 'admin' : 'user',
    //     login_count: 1,
    //     project_Id: user?.business?.id,
    //     app_language: user?.lang,
    //     plan_type: user?.business?.active_subscription ? 'paid' : 'trial',
    //     ...(user?.business && {
    //       company: {
    //         id: user?.business?.id,
    //         name: user?.business?.name?.ar,
    //         created_at: Math.floor(new Date(user?.business?.created_at).getTime() / 1000).toString(),
    //         trial_ends: Math.floor(new Date(user?.business?.date).getTime() / 1000).toString(),
    //         plan: user?.business?.active_subscription ? 'paid' : 'trial',
    //       },
    //     }),
    //   },
    // ]);
    // window.productFruitsUser = {
    //   username: user?.id,
    //   email: user?.email,
    //   firstname: user?.name?.ar,
    //   lastname: user?.name?.en,
    //   signUpAt: Math.floor(new Date(user?.date_joined).getTime() / 1000).toString(), // Sign up date (yyyy-mm-ddThh:mm:ss)
    //   role: user?.business?.is_owner ? 'admin' : 'user',
    // };
  }
};

export { setChatSession };
